export const CognitoConstants = {
  cognitoIdAttribute: 'sub',
  customerIdAttribute: 'custom:customer_id',
  lmsCustomerIdsAttribute: 'custom:lms_customer_ids',
  showPaidOffAttribute: 'custom:show_paid_off',
  phoneNumberAttribute: 'phone_number',
  phoneNumberVerifiedAttribute: 'phone_number_verified',
  emailAttribute: 'email',
  emailVerifiedAttribute: 'email_verified',
  mdmIdAttribute: 'custom:mdm_id',
  ncrAttribute: 'custom:non_customer_refer',
  loanStateAttribute: 'custom:loan_state',
  lmsReferenceTlxe: 'TLXe',
  lmsReferenceNls: 'NLS'
}

export const RegexConstants = {
  stateNameFormatting: /\w*/g,
  phoneNumberFormatting: /[-() ]?/g,
  phoneNumberFormattingExpress: /\D/g,
  currencyFormatting: /(\d)(?=(\d{3})+\.)/g,
  storeHoursFormatting: /[am|pm]?/ig,
  lettersTest: /[A-Za-z]+/,
  lowercaseLettersTest: /[a-z]+/,
  uppercaseLettersTest: /[A-Z]+/,
  numbersTest: /[0-9]+/,
  specialCharactersTest: /[`~!@#$%^&*()+=[{\]}|\\'<,.>?/";:\-_]/, // /`|~|!|@|#|\$|%|\^|&|\*|(|)|\+|=|[|{|]|}|\||\\|'|<|,|\.|>|\?|\/|"|;|:|-|_|s/,
  loanNumberTest: /^\d{5}-?\d{1,}-?\d{1,}$/,
  phoneNumberTest: /^[(]?[2-9]{1}\d{2}[) -]{0,2}\d{3}[ -]?\d{4}$/,
  dateTest: /^(?:(?:(?:0?[13578]|1[02])(\/|-|\.)31)\1|(?:(?:0?[1,3-9]|1[0-2])(\/|-|\.)(?:29|30)\2))(?:(?:1[6-9]|[2-9]\d)?\d{2})$|^(?:0?2(\/|-|\.)29\3(?:(?:(?:1[6-9]|[2-9]\d)?(?:0[48]|[2468][048]|[13579][26])|(?:(?:16|[2468][048]|[3579][26])00))))$|^(?:(?:0?[1-9])|(?:1[0-2]))(\/|-|\.)(?:0?[1-9]|1\d|2[0-8])\4(?:(?:1[6-9]|[2-9]\d)?\d{2})$/,
  titleCaseTest: /(\w)(\w*)/g,
  partialPhone: /^[0-9]{3}/,
  ccExpirationFormatTest: /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/, // Wasn't used in PWA, updated value with express version
  zipCodeTest: /^\d{5}$/,
  mobileDeviceTest1: /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge|maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,
  mobileDeviceTest2: /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i,
  nameTest: /^[a-z '-]+$/i,
  ssnTest: /^(?!(000|666|9))\d{3}-(?!00)\d{2}-(?!0000)\d{4}$/,
  notNumbers: /[^0-9]+/g,
  emptySpaces: /[ ]+/g,
  alphaNumeric: /[^0-9a-zA-Z]+/g,
  dashes: /[-]/g, // Selects values that are dashes
  tinTest: /[0-9-]/g, // Checks if all values are numbers or dashes
  partialTin: /^[0-9]{3}/, // Checks if the first 3 characters are numbers
  alphaNumericDashes: /[^0-9a-zA-Z-]+/g,
  name: /^[A-Za-z.'\- ]+$/,
  lenderName: /^[a-zA-Z0-9\s.'-]+$/,
  addressSpecialCharacters: /[^a-zA-Z0-9,.-\s]/ // Allows alphanumeric |,|.|-| blank space.
}

export const SettingsConstants = { // Using let so values are "live"
  sessionTimeoutMinutes: 5,
  defaultLanguage: 'en',
  defaultApiTimeout: 35000, // 35 seconds
  pastDuePhoneDayLimit: 60, // 60 days
  paymentTimeoutLimit: 30,
  refiPaymentTimeoutLimit: 30,
  signingStatusTimeoutLimit: 15, // Seconds
  shortCacheTimeout: 300000, // 5 minutes
  cacheTimeout: 1800000, // 30 minutes
  mediumCacheTimeout: 3600000, // 1 hour
  longCacheTimeout: 21600000, // 6 hours
  maxMoneyGramDisbursement: 10000,
  allowNoSsnRefi: false,
  appVersion: 'BROWSER',
  allowManageNotifications: true,
  loanDocUploadFileTypes: 'image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  loanDocAllowedFileTypes: '.JPG,.JPEG,.PNG,.GIF,.TIFF,.PDF,.DOC,.DOCX',
  loanDocUploadMaxSize: 4, // 4 MB
  loanDocUploadFileLimit: 10,
  isPresentationMode: false,
  maxDisburseCardLimit: 5,
  disbursementMaxPollingAttempts: 10,
  settlementPaymentRetryLimit: 2,
  restrictedRetryTimeInMins: 15,
  loanOriginateTimeout: 60, // 60 seconds
  postDrawTimeout: 45, // 45 seconds
  cancelRefiTimeout: 60, // 60 seconds
  resendCodeTimeout: 10, // 10 seconds
  confirmationRetries: 3,
  baseAwsUrl: process.env.VUE_APP_SERVICE_URL,
  requestTimeout: 35000, // 35 seconds
  localeCurrencyConfig: { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0, currencyDisplay: 'symbol' },

  allowedLanguages: [
    {
      key: 'en',
      value: 'English'
    },
    {
      key: 'sp',
      value: 'Spanish'
    }
  ]
}

export const KeyConstants = {
  paymentsBeforeAppReview: 3, // The number of payments the user must make (after their first payment) before the app asks for an app review
  appReviewPaymentCounter: 0, // The number of payments made since the last time the app asked for an app review, if the user submits an app review or chooses do not ask again, this will be set to -1 and will prevent further app review prompts
  signingStatusSignComplete: 'signing_complete', // Pulled from DocuSign callback URL to tell when document signing is done
  signingStatusViewComplete: 'viewing_complete', // Pulled from DocuSign callback URL, returned after documents have been signed and user views again
  signingStatusSignDecline: 'decline',
  signingStatusSignExpired: 'ttl_expired',
  deviceKey: 'deviceKey',
  viewedOfferIds: 'viewedOfferIds',
  creditLimitChange: 'creditLimitChange',
  gpsPermissionRequested: 'gpsPermissionRequested',
  resumeRefiModal: 'resumeRefiModal',
  resumeReapplyModal: 'resumeReapplyModal',
  incompleteApplicationModal: 'incompleteApplicationModal',
  selectedLanguage: 'selectedLanguage',
  waitLoadExclude: 'wait_exclude_',
  gpsDisabledEvent: 'gpsDisabledEvent',
  sessionId: 'sessionId',
  forgotPasswordUsername: 'forgotPasswordUsername',

  lmsIds: {
    TLXe: 'TLXe'
  },

  modals: {
    locationDisabled: 'locationDisabled'
  },

  leadEvents: {
    events: {
      applicationStarted: 'appStarted',
      submitted: 'appSubmitted',
      appraisalAppointment: 'appraisalAppt',
      approvedAppointment: 'approvedAppt'
    },

    status: {
      new: 'new',
      returning: 'returning',
      declined: 'declined',
      continue: 'continue with Appraisal'
    }
  },

  sessionStorage: {
    allowSelfAppraisal: 'allowSelfAppraisal',
    appraisalId: 'appraisalId',
    storeNumber: 'storeNumber',
    sessionAccessToken: 'sessionAccessToken',
    textSent: 'textSent',
    loanProduct: 'loanProduct'
  },

  cookies: {
    ccfiStoreNumberRedirect: 'redirect_ccfiStoreNumberV2',
    qrScanStoreNumberRedirect: 'redirect_qrScanStoreNumber',
    deviceKey: 'deviceKey'
  }
}

/**
 * These URLs do no change based on environment.
 */
export const UrlConstants = Object.freeze({
  accountSiteUrl: {
    c1l: 'account.cash1loans.com',
    ccc: 'account.californiacheckcash.com',
    ccf: 'account.ccfi.com',
    chs: 'account.checksmart.com',
    cic: 'account.checkintocash.com',
    esm: 'account.easymoney.com',
    inl: 'account.instaloan.com',
    tbs: 'account.titlebucks.com',
    tmx: 'account.titlemax.com'
  }
})

export const AnalyticsConstants = {
  eventName: {
    addPaymentInfo: 'add_payment_info',
    beginPayment: 'begin_checkout',
    finishPayment: 'ecommerce_purchase', // CT specific event
    completeCheckout: 'complete_checkout',
    linkAccount: 'link_account',
    login: 'login',
    logout: 'logout',
    register: 'sign_up', // CT specific event
    passwordChange: 'password_change',
    productSwitchCompleted: 'product_switch_finished',
    selectContent: 'select_content',
    viewItem: 'view_item',
    presentOffer: 'present_offer',
    submitContent: 'submit_content',
    portalTransaction: 'portal_transaction', // Iterable specific event
    portalAppointment: 'portal_appointment', // Iterable specific event
    accountCreated: 'account_created', // Iterable specific event
    pwaInstalled: 'pwa_installed', // Iterable specific event
    createAppointment: 'create_appointment', // CT specific event
    joinGroup: 'join_group',
    cashOut: 'cash_out',
    portalLaunched: 'portal_launched',
    error: 'portal_error',
    share: 'share',
    screenView: 'screen_view',
    changeContent: 'change_content',
    selectItem: 'select_item',
    tmxExpressApplication: 'TM_Express_Application',
    selectPromotion: 'select_promotion',
    contact: 'contact'
  },
  propName: {
    customerId: 'customer_id',
    mobileTLXeCustomerId: 'MobileTLXeCustomerId',
    isMobileGenerated: 'IsMobileGenerated',
    usernameTypeUser: 'username_type',
    amountDue: 'amount_due',
    isPwa: 'progressive_web_app_installed',
    allowAdFeatures: 'allowAdFeatures',

    email: 'Email',
    phone: 'Phone',

    /**
     * The environment that user is currently associated with. This allows environment to be added to all events including events auto captured by Firebase.
     */
    environment: 'environment',

    /**
     * The branding of the site that events are being recorded from.
     */
    siteBrand: 'site_brand'
  },
  other: {
    disbursementPayType: 'disbursement',
    cancelRestrictStateRefiPayType: 'canceledRestrictedStateRefinance',
    cancelRefiPayType: 'canceledRefinance',
    refiPayType: 'refinance',
    resolutionPayoff: 'resolution payoff',
    standardPayType: 'standard',
    payoffPayType: 'payoff',
    disbursement: 'disbursement',
    cancelCheckoutType: 'cancel',
    completeCheckoutType: 'success',
    personalLoan: 'Personal',
    titleLoan: 'Title'
  },
  method: {
    loginType: {
      email: 'email',
      phone: 'phoneNumber'
    },
    passChange: {
      forgotPassword: 'forgotPassword'
    },
    logout: {
      reviewPayment: 'reviewPayment',
      sideBarButton: 'sideBarButton',
      sessionTimeout: 'sessionTimeout',
      trustedDeviceFailure: 'trustedDeviceFailure',
      networkError: 'networkError',
      profileLock: 'profileLock',
      updateUsername: 'updateUsername'
    }
  },
  medium: {
    login: {
      password: 'password'
    }
  },
  itemType: {
    phone: 'phone',
    email: 'email',
    termsConditionsConsent: 'termsConditionsConsent',
    pdf: 'pdf',
    ancillaryProduct: 'ancillaryProduct',
    expressLane: 'expressLane',
    disbursement: 'disbursement',
    externalApp: 'externalApp',
    progressive_web_app: 'PWA',
    standardPay: 'standard',
    guestPay: 'guest'
  },

  userProperties: {
    /**
     * Used to merge profiles and match to Vergent customer info.
     */
    mobileTLXeCustomerId: 'MobileTLXeCustomerId',

    /**
     * Used to merge profiles.
     */
    isMobileGenerated: 'IsMobileGenerated',

    /**
     * The environment that user is currently associated with. This allows environment to be added to all events including events auto captured by Firebase.
     */
    environment: 'environment',

    /**
     * The user's entered email address. Used as an additional identity.
     */
    email: 'Email',

    /**
     * The user's entered phone number.
     */
    phoneNumber: 'Phone',

    /**
     * The unique session id generated per each session for Firebase Analytic reporting
     */
    customSessionId: 'custom_session_id',

    /**
     * The unique customer id for Firebase Analytic reporting
     */
    customerId: 'customer_id',

    /**
     * The customer's application id for Firebase Analytic reporting
     */
    applicationId: 'application_id',

    /**
     * The branding of the site that events are being recorded from.
     */
    siteBrand: 'site_brand',

    /**
     * The type of application running (express portal versus fast track appraiser mobile app).
     */
    applicationType: 'application_type',

    /**
     * The type of customer doing the application (new or returning).
     */
    customerType: 'customer_type',

    /**
     * Used to provide deep link.
     */
    FastTrackLink: 'FastTrackLink'
  },

  attributeValues: {
    productType: {
      signature: 'Signature',
      title: 'Title'
    },

    loanProductType: {
      signature: 'personal',
      title: 'title'
    },

    reason: {
      unsupportedState: 'unsupported state',
      ageVerification: 'age verification',
      bankruptcy: 'bankruptcy',
      identityVerification: 'identity verification',
      mla: 'mla',
      mlv: 'mlv',
      prescoreDeclined: 'prescore declined'
    },

    status: {
      personalComplete: 'personal_complete',
      vehicleComplete: 'vehicle_complete',
      financialComplete: 'financial_complete',
      submitted: 'submitted',
      declined: 'declined',
      scheduled: 'scheduled',
      selected: 'selected'
    },

    vehicleStatus: {
      financed: 'financed',
      owned: 'owned'
    },

    prescore: {
      declined: 'declined',
      continue: 'continue with Appraisal'
    },

    notApplicable: 'Not Applicable',
    applicationType: 'express_portal',

    cppVideoStatus: {
      started: 'started',
      completed: 'completed'
    },

    contactMethods: {
      email: 'email',
      text: 'text',
      voice: 'voice'
    },

    urlTypes: {
      titleMaxMainLogoSite: 'TitleMaxMainLogoSite',
      instaLoanMainLogoSite: 'InstaLoanMainLogoSite',
      titleBucksMainLogoSite: 'TitleBucksMainLogoSite'
    },

    appointmentType: {
      approval: 'approval',
      appraisal: 'appraisal'
    },

    calendarTypes: {
      android: 'android',
      google: 'google',
      iOS: 'iOS'
    }
  }
}

export const PreferenceKeys = {
  termsConditionsConsent: 'termsConditionsConsent'
}

export const PaymentProcessorTypeEnum = Object.freeze({ 'CyberSource': 1, 'BridgePay': 4, 'Repay': 2, 'Mixed': 3, 'None': 5 })

export const LoanDetailDisplayTypesEnum = Object.freeze({ 'singleLoan': 1, 'twoLoansSingleStore': 2, 'multiLoansSingleStore': 3, 'multiStore': 4 })

export const MenuButtonEnum = Object.freeze({ 'none': 1, 'menu': 2, 'back': 3, 'cancel': 4 })

export const CancelReasonEnum = Object.freeze({ 'cancelRenewal': 1, 'statusChange': 2, 'restrictStateCancelRenewal': 3, 'optionalInsurance': 4 })

export const TooltipEnum = Object.freeze({ 'eligibleIncome': 1, 'militaryCovered': 2, 'paymentPlus': 3, 'fundsAvailable': 4, 'achEnrollment': 5, 'lastPayDate': 6, 'payDateFrequency': 7, 'discretionaryIncomeAmount': 8 })

export const LoanLockTypeEnum = Object.freeze({ 'RefiAltPartyLocked': 1 })

export const NotificationTypeEnum = Object.freeze({
  offer: 1,
  alert: 2,
  success: 3,
  failure: 4,
  info: 5
})

export const PaymentTypeEnum = Object.freeze({ none: 1, payment: 2, refinance: 3, settlement: 5 })

export const DisbursementTypeEnum = Object.freeze({
  none: 0,
  store: 2,
  bank: 4,
  moneyGram: 14,
  debit: 16,
  ach: 101 // ACH NLS type ID is over 100 to avoid potential future conflicts with Vergent types
})

export const DisbursementFlowTypeEnum = Object.freeze({
  payment: 1,
  draw: 2
})

export const DefaultPhoneNumbers = Object.freeze({
  TLXe: '1-888-485-3629'
})

export const TransactionMessageType = Object.freeze({
  Email: 0,
  Text: 1,
  Both: 2
})

export const RenewEnum = Object.freeze({
  Renew: 'renew',
  Renewal: 'renewal',
  Renewing: 'renewing'
})

export const DashboardItemType = Object.freeze({
  Loan: 0,
  TLXeApplication: 2
})

export const RestrictedModalReason = Object.freeze({
  Location: 0,
  MLA: 1,
  ReapplyUnderwriting: 2,
  CanRefinance: 3
})

export const SwitchTypes = Object.freeze({
  tmx: 'tmx',
  ccf: 'ccf'
})

export const BrandEnum = Object.freeze({
  None: 1,
  TitleMax: 2,
  TitleBucks: 3,
  InstaLoan: 4,
  CheckIntoCash: 5,
  EasyMoney: 6,
  CheckSmart: 7,
  CaliforniaCheckCash: 8,
  Cash1Loans: 9,
  CommunityChoice: 10
})

export const AppBrandThemeColor = Object.freeze({
  c1l: '#04733b',
  ccc: '#273995',
  ccf: '#204688',
  chs: '#00793e',
  cic: '#25836b',
  esm: '#386830',
  inl: '#2a8c00',
  rpc: '',
  spc: '',
  tbs: '#317222',
  tmx: '#00529b'
})

export const AppBrandBackgroundColor = Object.freeze({
  c1l: '#f7fef3',
  ccc: '#f2f4ff',
  ccf: '#eff8ff',
  chs: '#f4f8f1',
  cic: '#def1e8',
  esm: '#eef7ed',
  inl: '#abd798',
  rpc: '',
  spc: '',
  tbs: '#f6f9ec',
  tmx: '#b3e5fa'
})

export const AppBrandDisplayNameEnum = Object.freeze({
  c1l: 'CASH 1',
  ccc: 'California Check Cashing Stores',
  ccf: 'Community Choice Financial',
  cic: 'Check Into Cash',
  chs: 'CheckSmart',
  chs2: 'Check$mart',
  esm: 'easymoney',
  esmName: 'Easy Money',
  inl: 'InstaLoan',
  rpc: 'Rapid Cash',
  spc: 'Speedy Cash',
  tbs: 'TitleBucks',
  tmx: 'TitleMax'
})

export const AppBrandDisplayRNameEnum = Object.freeze({
  c1l: `${AppBrandDisplayNameEnum.c1l}®`,
  ccc: `${AppBrandDisplayNameEnum.ccc}®`,
  ccf: `${AppBrandDisplayNameEnum.ccf}®`,
  chs: `${AppBrandDisplayNameEnum.chs}®`,
  cic: `${AppBrandDisplayNameEnum.cic}®`,
  esm: `${AppBrandDisplayNameEnum.esm}™`,
  inl: `${AppBrandDisplayNameEnum.inl}®`,
  tbs: `${AppBrandDisplayNameEnum.tbs}®`,
  tmx: `${AppBrandDisplayNameEnum.tmx}®`
})

export const BrandNameEnum = Object.freeze({
  [BrandEnum.None]: '',
  [BrandEnum.Cash1Loans]: AppBrandDisplayRNameEnum.c1l,
  [BrandEnum.CaliforniaCheckCash]: AppBrandDisplayRNameEnum.ccc,
  [BrandEnum.CommunityChoice]: AppBrandDisplayRNameEnum.ccf,
  [BrandEnum.CheckSmart]: AppBrandDisplayRNameEnum.chs,
  [BrandEnum.CheckIntoCash]: AppBrandDisplayRNameEnum.cic,
  [BrandEnum.EasyMoney]: AppBrandDisplayRNameEnum.esm,
  [BrandEnum.InstaLoan]: AppBrandDisplayRNameEnum.inl,
  [BrandEnum.TitleBucks]: AppBrandDisplayRNameEnum.tbs,
  [BrandEnum.TitleMax]: AppBrandDisplayRNameEnum.tmx
})

export const BrandName = Object.freeze({
  checkSmart: 'Check$mart®',
  checkIntoCash: 'Check Into Cash®',
  easyMoney: 'easymoney™',
  instaLoan: 'InstaLoan®',
  rapidCash: 'Rapid Cash®',
  speedyCash: 'Speedy Cash®',
  titleBucks: 'TitleBucks®',
  titleMax: 'TitleMax®',
  communityChoice: 'Community Choice Financial®',
  communityChoiceWithoutR: 'Community Choice Financial',
  checkIntoCashWithoutR: 'Check Into Cash',
  checkSmartWithoutR: 'Check$mart',
  easyMoneyWithoutR: 'Easy Money',
  instaLoanWithoutR: 'InstaLoan',
  rapidCashWithoutR: 'Rapid Cash',
  speedyCashWithoutR: 'Speedy Cash',
  titleBucksWithoutR: 'TitleBucks',
  titleMaxWithoutR: 'TitleMax'
})

export const ServiceBrands = Object.freeze({
  None: 'none',
  Cash1Loans: 'cash 1 loans',
  CaliforniaCheckCash: 'california check cash',
  CommunityChoice: 'community choice financial',
  CheckSmart: 'check$mart',
  CheckIntoCash: 'check into cash',
  EasyMoney: 'easymoney',
  InstaLoan: 'instaloan',
  RapidCash: 'rapidcash',
  SpeedyCash: 'speedycash',
  TitleBucks: 'titlebucks',
  TitleMax: 'titlemax'
})

export const AppBrands = Object.freeze({
  c1l: 'c1l',
  ccc: 'ccc',
  ccf: 'ccf',
  chs: 'chs',
  cic: 'cic',
  esm: 'esm',
  inl: 'inl',
  rpc: 'rpc',
  spc: 'spc',
  tbs: 'tbs',
  tmx: 'tmx'
})

export const NavigationBrands = Object.freeze({
  Cash1Loans: 'Cash1Loans',
  CaliforniaCheckCash: 'CaliforniaCheckCash',
  CommunityChoice: 'CommunityChoice',
  CheckSmart: 'CheckSmart',
  CheckIntoCash: 'CheckIntoCash',
  EasyMoney: 'EasyMoney',
  InstaLoan: 'InstaLoan',
  RapidCash: 'RapidCash',
  SpeedyCash: 'SpeedyCash',
  TitleBucks: 'TitleBucks',
  TitleMax: 'TitleMax'
})

export const AppNavigationBrands = Object.freeze({
  c1l: NavigationBrands.Cash1Loans,
  ccc: NavigationBrands.CaliforniaCheckCash,
  ccf: NavigationBrands.CommunityChoice,
  chs: NavigationBrands.CheckSmart,
  cic: NavigationBrands.CheckIntoCash,
  esm: NavigationBrands.EasyMoney,
  inl: NavigationBrands.InstaLoan,
  rpc: NavigationBrands.RapidCash,
  spc: NavigationBrands.SpeedyCash,
  tbs: NavigationBrands.TitleBucks,
  tmx: NavigationBrands.TitleMax
})

export const ServiceBrandEnum = Object.freeze({
  [ServiceBrands.None]: BrandEnum.None,
  [ServiceBrands.Cash1Loans]: BrandEnum.Cash1Loans,
  [ServiceBrands.CaliforniaCheckCash]: BrandEnum.CaliforniaCheckCash,
  [ServiceBrands.CommunityChoice]: BrandEnum.CommunityChoice,
  [ServiceBrands.CheckSmart]: BrandEnum.CheckSmart,
  [ServiceBrands.CheckIntoCash]: BrandEnum.CheckIntoCash,
  [ServiceBrands.EasyMoney]: BrandEnum.EasyMoney,
  [ServiceBrands.InstaLoan]: BrandEnum.InstaLoan,
  [ServiceBrands.TitleBucks]: BrandEnum.TitleBucks,
  [ServiceBrands.TitleMax]: BrandEnum.TitleMax
})

export const AppointmentTypeEnum = Object.freeze({
  general: 1,
  productSwitch: 2,
  productSwitchAutoCreate: 3,
  approval: 4,
  appraisal: 5
})

export const OfferIdEnum = Object.freeze({
  settlement: 10,
  appraisal: 12,
  widget: 22
})

export const CookieConstants = Object.freeze({
  forceRefresh: {
    key: 'ForceRefresh',
    ttlMinutes: 5
  },
  networkError: 'NetworkError',
  gpsInstructionsReceipt: {
    key: 'GpsInstructionsReceipt',
    ttlSeconds: 604800
  },
  origination: {
    key: 'Origination',
    ttlMinutes: 7200 // 7200 is 5 days worth of minutes
  },
  locationValidated: {
    key: 'LocationValidated',
    ttlMinutes: 10
  }
})

export const ErrorTypes = Object.freeze({
  profileLocked: 'ProfileLocked'
})

export const DefaultPasswordPolicy = Object.freeze({
  minimumLength: 9,
  requireUppercase: true,
  requireLowercase: true,
  requireNumbers: true,
  requireSymbols: false,
  requireNoSpaces: true
})

export const Cards = Object.freeze({
  transactionType: {
    /**
     * Cards are used for making payments on loans.
     */
    payment: {
      id: 1,
      name: 'payment'
    },

    /**
     * Cards are used for push to debit disbursement method.
     */
    disbursement: {
      id: 2,
      name: 'disbursement'
    },

    /**
     * Cards are used for push to debit disbursement method.
     */
    refer: {
      id: 3,
      name: 'refer'
    }
  }
})

export const OsType = Object.freeze({
  Android: 'Android',
  Apple: 'Apple',
  Unknown: 'Unknown'
})

export const DesktopOsType = Object.freeze({
  Windows: 'Windows',
  Mac: 'Mac',
  Unknown: 'Unknown'
})

export const BrowserType = Object.freeze({
  Chrome: 'Chrome',
  Safari: 'Safari',
  Samsung: 'Samsung',
  Unknown: 'Unknown'
})

export const SigningType = Object.freeze({
  loanOriginate: 'LoanOriginate',
  refinance: 'Refinance'
})

export const DisclosureType = Object.freeze({
  application: 'application',
  appraisal: 'appraisal',
  reapply: 'reapply',
  refinance: 'refinance'
})

export const TransactionType = Object.freeze({
  addOn: 'AddOn',
  payment: 'Payment',
  refi: 'Refi'
})

export const NcrType = Object.freeze({
  customer: 'customer'
})

export const ReferralType = Object.freeze({
  none: 'none',
  ncr: 'ncr',
  ecr: 'ecr'
})

export const ReferralSource = Object.freeze({
  email: 'email',
  text: 'text',
  share: 'share',
  qr: 'qr'
})

export const CardTypeEnum = Object.freeze({
  amex: 'amex',
  discover: 'discover',
  masterCard: 'mastercard',
  visa: 'visa',
  bank: 'bank'
})

export const AutoPayType = Object.freeze({
  card: 'card',
  bank: 'bank'
})

export const TlxeLoanStatusEnum = Object.freeze({
  PaidOff: 3,
  ChargedOff: 6,
  Closed: 8,
  Deleted: 10,
  Open: 12,
  Repossessed: 13,
  OutForRepo: 15,
  Sold: 16,
  Bankrupt: 17,
  Refinance: 22,
  OutForRepoChargedOff: 23,
  RepossessedChargedOff: 24,
  Default: 27,
  Rescinded: 28,
  Settled: 29,
  ActiveDefault: 31,
  BankruptChargedOff: 32,
  Chargeback: 33
})

export const ModalIdentifier = Object.freeze({
  locationDisclaimer: 'locationDisclaimerModal',
  productSwitchOffer: 'productSwitchModal',
  paymentLimit: 'paymentLimitModal'
})

export const AllowedNumericKeys = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  'ArrowLeft',
  'ArrowRight',
  'Backspace',
  'Delete',
  'Tab'
]

export const CustomerTypes = {
  new: 'new',
  returning: 'returning'
}

export const LoanProductTypes = {
  signatureLoan: 'signature_loan',
  titleLoan: 'title_loan'
}

export const EmploymentLength = {
  hours_yes: 'thirty_plus',
  hours_no: 'thirty_minus',
  length_yes: 'six_plus',
  length_no: 'less_than_six'
}

export const IdTypeSelections = {
  driversLicense: 'DL',
  state: 'STATE',
  passport: 'PASSPORT',
  matricula: 'MATRICULA'
}

export const ReturnCustIndicatorTypes = {
  empty: 0,
  personal: 1,
  financial: 2,
  submitted: 3,
  none: 4
}

export const inputBehaviorTypes = {
  typed: 'TYPED',
  autofill: 'AUTO_FILL',
  copyPasted: 'COPY_PASTED',
  prefilled: 'PREFILLED'
}

export const ElementStatus = {
  Disabled: 0,
  Active: 1,
  Editable: 2
}

export const DeviceBreakPoints = {
  MOBILE_BREAKPOINT: 576
}

export const BAD_TINS = [
  '111111111',
  '222222222',
  '333333333',
  '444444444',
  '555555555',
  '666666666',
  '777777777',
  '888888888',
  '999999999',
  '123456789',
  '987654321'
]

export const idSelectionOptions = [
  {
    displayName: 'global.state_id',
    route: 'IdState',
    type: 'STATE'
  },
  {
    displayName: 'global.passport',
    route: 'IdPassport',
    type: 'PASSPORT'
  },
  {
    displayName: 'global.matricula_consular',
    route: 'IdMatriculaConsular',
    type: 'MATRICULA'
  },
  {
    displayName: 'global.drivers_license',
    route: 'IdDriversLicense',
    type: 'DL'
  }
]

export const incomeFrequencyOptions = [
  { value: 'WEEKLY', text: 'Once a week' },
  { value: 'BI-WEEKLY', text: 'Every other week' },
  { value: 'SEMI-MONTHLY', text: 'Twice a month' },
  { value: 'MONTHLY', text: 'Once a month' }
]

export const daysOfTheWeek = [
  { value: 'MONDAY', text: 'Monday' },
  { value: 'TUESDAY', text: 'Tuesday' },
  { value: 'WEDNESDAY', text: 'Wednesday' },
  { value: 'THURSDAY', text: 'Thursday' },
  { value: 'FRIDAY', text: 'Friday' }
]

export const ordinalNumbers = [
  { value: '1ST', text: '1st' },
  { value: '2ND', text: '2nd' },
  { value: '3RD', text: '3rd' },
  { value: '4TH', text: '4th' },
  { value: '5TH', text: '5th' },
  { value: '6TH', text: '6th' },
  { value: '7TH', text: '7th' },
  { value: '8TH', text: '8th' },
  { value: '9TH', text: '9th' },
  { value: '10TH', text: '10th' },
  { value: '11TH', text: '11th' },
  { value: '12TH', text: '12th' },
  { value: '13TH', text: '13th' },
  { value: '14TH', text: '14th' },
  { value: '15TH', text: '15th' },
  { value: '16TH', text: '16th' },
  { value: '17TH', text: '17th' },
  { value: '18TH', text: '18th' },
  { value: '19TH', text: '19th' },
  { value: '20TH', text: '20th' },
  { value: '21ST', text: '21st' },
  { value: '22ND', text: '22nd' },
  { value: '23RD', text: '23rd' },
  { value: '24TH', text: '24th' },
  { value: '25TH', text: '25th' },
  { value: '26TH', text: '26th' },
  { value: '27TH', text: '27th' },
  { value: '28TH', text: '28th' },
  { value: '29TH', text: '29th' },
  { value: '30TH', text: '30th' },
  { value: 'LAST', text: 'Last' }
]

export const ordinalNumberWords = [
  { value: 'FIRST', text: 'First' },
  { value: 'SECOND', text: 'Second' },
  { value: 'THIRD', text: 'Third' },
  { value: 'FOURTH', text: 'Fourth' },
  { value: 'LAST', text: 'Last' }
]

export const daysSemimonthlyOptions = [
  { value: '1ST AND 15TH', text: '1st and 15th' },
  { value: '5TH AND 20TH', text: '5th and 20th' },
  { value: '7TH AND 22ND', text: '7th and 22nd' },
  { value: '10TH AND 25TH', text: '10th and 25th' },
  { value: '15TH AND LAST DAY', text: '15th and Last Day' }
]

export const LIST_OF_STATES = [
  { value: 'AL', text: 'Alabama' },
  { value: 'AK', text: 'Alaska' },
  { value: 'AZ', text: 'Arizona' },
  { value: 'AR', text: 'Arkansas' },
  { value: 'CA', text: 'California' },
  { value: 'CO', text: 'Colorado' },
  { value: 'CT', text: 'Connecticut' },
  { value: 'DE', text: 'Delaware' },
  { value: 'FL', text: 'Florida' },
  { value: 'GA', text: 'Georgia' },
  { value: 'HI', text: 'Hawaii' },
  { value: 'ID', text: 'Idaho' },
  { value: 'IL', text: 'Illinois' },
  { value: 'IN', text: 'Indiana' },
  { value: 'IA', text: 'Iowa' },
  { value: 'KS', text: 'Kansas' },
  { value: 'KY', text: 'Kentucky' },
  { value: 'LA', text: 'Louisiana' },
  { value: 'ME', text: 'Maine' },
  { value: 'MD', text: 'Maryland' },
  { value: 'MA', text: 'Massachusetts' },
  { value: 'MI', text: 'Michigan' },
  { value: 'MN', text: 'Minnesota' },
  { value: 'MS', text: 'Mississippi' },
  { value: 'MO', text: 'Missouri' },
  { value: 'MT', text: 'Montana' },
  { value: 'NE', text: 'Nebraska' },
  { value: 'NV', text: 'Nevada' },
  { value: 'NH', text: 'New Hampshire' },
  { value: 'NJ', text: 'New Jersey' },
  { value: 'NM', text: 'New Mexico' },
  { value: 'NY', text: 'New York' },
  { value: 'NC', text: 'North Carolina' },
  { value: 'ND', text: 'North Dakota' },
  { value: 'OH', text: 'Ohio' },
  { value: 'OK', text: 'Oklahoma' },
  { value: 'OR', text: 'Oregon' },
  { value: 'PA', text: 'Pennsylvania' },
  { value: 'RI', text: 'Rhode Island' },
  { value: 'SC', text: 'South Carolina' },
  { value: 'SD', text: 'South Dakota' },
  { value: 'TN', text: 'Tennessee' },
  { value: 'TX', text: 'Texas' },
  { value: 'UT', text: 'Utah' },
  { value: 'VT', text: 'Vermont' },
  { value: 'VA', text: 'Virginia' },
  { value: 'WA', text: 'Washington' },
  { value: 'WV', text: 'West Virginia' },
  { value: 'WI', text: 'Wisconsin' },
  { value: 'WY', text: 'Wyoming' },
  { value: 'DC', text: 'District Of Columbia' }
  //   { value: "GU", text: "Guam" },
  //   { value: "PR", text: "Puerto Rico" },
  //   { value: "AS", text: "American Samoa" },
  //   { value: "FM", text: "Federated States Of Micronesia" },
  //   { value: "MH", text: "Marshall Islands" },
  //   { value: "MP", text: "Northern Mariana Islands" },
  //   { value: "PW", text: "Palau" },
  //   { value: "VI", text: "Virgin Islands" }
]

export const ALLOWED_NUMERIC_KEYS = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  'ArrowLeft',
  'ArrowRight',
  'Backspace',
  'Delete',
  'Tab'
]

export const ALLOWED_EDIT_KEYS = [
  'ArrowLeft',
  'ArrowRight',
  'Backspace',
  'Delete',
  'Tab'
]

export const LIST_OF_COUNTRIES = [
  { value: 'US', text: 'United States' },
  { value: 'MX', text: 'Mexico' },
  { value: 'CA', text: 'Canada' },
  { value: 'AF', text: 'Afghanistan' },
  { value: 'AX', text: 'Åland Islands' },
  { value: 'AL', text: 'Albania' },
  { value: 'DZ', text: 'Algeria' },
  { value: 'AS', text: 'American Samoa' },
  { value: 'AD', text: 'Andorra' },
  { value: 'AO', text: 'Angola' },
  { value: 'AI', text: 'Anguilla' },
  { value: 'AQ', text: 'Antarctica' },
  { value: 'AG', text: 'Antigua and Barbuda' },
  { value: 'AR', text: 'Argentina' },
  { value: 'AM', text: 'Armenia' },
  { value: 'AW', text: 'Aruba' },
  { value: 'AU', text: 'Australia' },
  { value: 'AT', text: 'Austria' },
  { value: 'AZ', text: 'Azerbaijan' },
  { value: 'BS', text: 'Bahamas' },
  { value: 'BH', text: 'Bahrain' },
  { value: 'BD', text: 'Bangladesh' },
  { value: 'BB', text: 'Barbados' },
  { value: 'BY', text: 'Belarus' },
  { value: 'BE', text: 'Belgium' },
  { value: 'BZ', text: 'Belize' },
  { value: 'BJ', text: 'Benin' },
  { value: 'BM', text: 'Bermuda' },
  { value: 'BT', text: 'Bhutan' },
  { value: 'BO', text: 'Bolivia, Plurinational State of' },
  { value: 'BQ', text: 'Bonaire, Sint Eustatius and Saba' },
  { value: 'BA', text: 'Bosnia and Herzegovina' },
  { value: 'BW', text: 'Botswana' },
  { value: 'BV', text: 'Bouvet Island' },
  { value: 'BR', text: 'Brazil' },
  { value: 'IO', text: 'British Indian Ocean Territory' },
  { value: 'BN', text: 'Brunei Darussalam' },
  { value: 'BG', text: 'Bulgaria' },
  { value: 'BF', text: 'Burkina Faso' },
  { value: 'BI', text: 'Burundi' },
  { value: 'KH', text: 'Cambodia' },
  { value: 'CM', text: 'Cameroon' },
  { value: 'CV', text: 'Cape Verde' },
  { value: 'KY', text: 'Cayman Islands' },
  { value: 'CF', text: 'Central African Republic' },
  { value: 'TD', text: 'Chad' },
  { value: 'CL', text: 'Chile' },
  { value: 'CN', text: 'China' },
  { value: 'CX', text: 'Christmas Island' },
  { value: 'CC', text: 'Cocos (Keeling) Islands' },
  { value: 'CO', text: 'Colombia' },
  { value: 'KM', text: 'Comoros' },
  { value: 'CG', text: 'Congo' },
  { value: 'CD', text: 'Congo, the Democratic Republic of the' },
  { value: 'CK', text: 'Cook Islands' },
  { value: 'CR', text: 'Costa Rica' },
  { value: 'CI', text: "Côte d'Ivoire" },
  { value: 'HR', text: 'Croatia' },
  { value: 'CU', text: 'Cuba' },
  { value: 'CW', text: 'Curaçao' },
  { value: 'CY', text: 'Cyprus' },
  { value: 'CZ', text: 'Czech Republic' },
  { value: 'DK', text: 'Denmark' },
  { value: 'DJ', text: 'Djibouti' },
  { value: 'DM', text: 'Dominica' },
  { value: 'DO', text: 'Dominican Republic' },
  { value: 'EC', text: 'Ecuador' },
  { value: 'EG', text: 'Egypt' },
  { value: 'SV', text: 'El Salvador' },
  { value: 'GQ', text: 'Equatorial Guinea' },
  { value: 'ER', text: 'Eritrea' },
  { value: 'EE', text: 'Estonia' },
  { value: 'ET', text: 'Ethiopia' },
  { value: 'FK', text: 'Falkland Islands (Malvinas)' },
  { value: 'FO', text: 'Faroe Islands' },
  { value: 'FJ', text: 'Fiji' },
  { value: 'FI', text: 'Finland' },
  { value: 'FR', text: 'France' },
  { value: 'GF', text: 'French Guiana' },
  { value: 'PF', text: 'French Polynesia' },
  { value: 'TF', text: 'French Southern Territories' },
  { value: 'GA', text: 'Gabon' },
  { value: 'GM', text: 'Gambia' },
  { value: 'GE', text: 'Georgia' },
  { value: 'DE', text: 'Germany' },
  { value: 'GH', text: 'Ghana' },
  { value: 'GI', text: 'Gibraltar' },
  { value: 'GR', text: 'Greece' },
  { value: 'GL', text: 'Greenland' },
  { value: 'GD', text: 'Grenada' },
  { value: 'GP', text: 'Guadeloupe' },
  { value: 'GU', text: 'Guam' },
  { value: 'GT', text: 'Guatemala' },
  { value: 'GG', text: 'Guernsey' },
  { value: 'GN', text: 'Guinea' },
  { value: 'GW', text: 'Guinea-Bissau' },
  { value: 'GY', text: 'Guyana' },
  { value: 'HT', text: 'Haiti' },
  { value: 'HM', text: 'Heard Island and McDonald Islands' },
  { value: 'VA', text: 'Holy See (Vatican City State)' },
  { value: 'HN', text: 'Honduras' },
  { value: 'HK', text: 'Hong Kong' },
  { value: 'HU', text: 'Hungary' },
  { value: 'IS', text: 'Iceland' },
  { value: 'IN', text: 'India' },
  { value: 'ID', text: 'Indonesia' },
  { value: 'IR', text: 'Iran, Islamic Republic of' },
  { value: 'IQ', text: 'Iraq' },
  { value: 'IE', text: 'Ireland' },
  { value: 'IM', text: 'Isle of Man' },
  { value: 'IL', text: 'Israel' },
  { value: 'IT', text: 'Italy' },
  { value: 'JM', text: 'Jamaica' },
  { value: 'JP', text: 'Japan' },
  { value: 'JE', text: 'Jersey' },
  { value: 'JO', text: 'Jordan' },
  { value: 'KZ', text: 'Kazakhstan' },
  { value: 'KE', text: 'Kenya' },
  { value: 'KI', text: 'Kiribati' },
  { value: 'KP', text: "Korea, Democratic People's Republic of" },
  { value: 'KR', text: 'Korea, Republic of' },
  { value: 'KW', text: 'Kuwait' },
  { value: 'KG', text: 'Kyrgyzstan' },
  { value: 'LA', text: "Lao People's Democratic Republic" },
  { value: 'LV', text: 'Latvia' },
  { value: 'LB', text: 'Lebanon' },
  { value: 'LS', text: 'Lesotho' },
  { value: 'LR', text: 'Liberia' },
  { value: 'LY', text: 'Libya' },
  { value: 'LI', text: 'Liechtenstein' },
  { value: 'LT', text: 'Lithuania' },
  { value: 'LU', text: 'Luxembourg' },
  { value: 'MO', text: 'Macao' },
  { value: 'MK', text: 'Macedonia, the former Yugoslav Republic of' },
  { value: 'MG', text: 'Madagascar' },
  { value: 'MW', text: 'Malawi' },
  { value: 'MY', text: 'Malaysia' },
  { value: 'MV', text: 'Maldives' },
  { value: 'ML', text: 'Mali' },
  { value: 'MT', text: 'Malta' },
  { value: 'MH', text: 'Marshall Islands' },
  { value: 'MQ', text: 'Martinique' },
  { value: 'MR', text: 'Mauritania' },
  { value: 'MU', text: 'Mauritius' },
  { value: 'YT', text: 'Mayotte' },
  { value: 'FM', text: 'Micronesia, Federated States of' },
  { value: 'MD', text: 'Moldova, Republic of' },
  { value: 'MC', text: 'Monaco' },
  { value: 'MN', text: 'Mongolia' },
  { value: 'ME', text: 'Montenegro' },
  { value: 'MS', text: 'Montserrat' },
  { value: 'MA', text: 'Morocco' },
  { value: 'MZ', text: 'Mozambique' },
  { value: 'MM', text: 'Myanmar' },
  { value: 'NA', text: 'Namibia' },
  { value: 'NR', text: 'Nauru' },
  { value: 'NP', text: 'Nepal' },
  { value: 'NL', text: 'Netherlands' },
  { value: 'NC', text: 'New Caledonia' },
  { value: 'NZ', text: 'New Zealand' },
  { value: 'NI', text: 'Nicaragua' },
  { value: 'NE', text: 'Niger' },
  { value: 'NG', text: 'Nigeria' },
  { value: 'NU', text: 'Niue' },
  { value: 'NF', text: 'Norfolk Island' },
  { value: 'MP', text: 'Northern Mariana Islands' },
  { value: 'NO', text: 'Norway' },
  { value: 'OM', text: 'Oman' },
  { value: 'PK', text: 'Pakistan' },
  { value: 'PW', text: 'Palau' },
  { value: 'PS', text: 'Palestinian Territory, Occupied' },
  { value: 'PA', text: 'Panama' },
  { value: 'PG', text: 'Papua New Guinea' },
  { value: 'PY', text: 'Paraguay' },
  { value: 'PE', text: 'Peru' },
  { value: 'PH', text: 'Philippines' },
  { value: 'PN', text: 'Pitcairn' },
  { value: 'PL', text: 'Poland' },
  { value: 'PT', text: 'Portugal' },
  { value: 'PR', text: 'Puerto Rico' },
  { value: 'QA', text: 'Qatar' },
  { value: 'RE', text: 'Réunion' },
  { value: 'RO', text: 'Romania' },
  { value: 'RU', text: 'Russian Federation' },
  { value: 'RW', text: 'Rwanda' },
  { value: 'BL', text: 'Saint Barthélemy' },
  { value: 'SH', text: 'Saint Helena, Ascension and Tristan da Cunha' },
  { value: 'KN', text: 'Saint Kitts and Nevis' },
  { value: 'LC', text: 'Saint Lucia' },
  { value: 'MF', text: 'Saint Martin (French part)' },
  { value: 'PM', text: 'Saint Pierre and Miquelon' },
  { value: 'VC', text: 'Saint Vincent and the Grenadines' },
  { value: 'WS', text: 'Samoa' },
  { value: 'SM', text: 'San Marino' },
  { value: 'ST', text: 'Sao Tome and Principe' },
  { value: 'SA', text: 'Saudi Arabia' },
  { value: 'SN', text: 'Senegal' },
  { value: 'RS', text: 'Serbia' },
  { value: 'SC', text: 'Seychelles' },
  { value: 'SL', text: 'Sierra Leone' },
  { value: 'SG', text: 'Singapore' },
  { value: 'SX', text: 'Sint Maarten (Dutch part)' },
  { value: 'SK', text: 'Slovakia' },
  { value: 'SI', text: 'Slovenia' },
  { value: 'SB', text: 'Solomon Islands' },
  { value: 'SO', text: 'Somalia' },
  { value: 'ZA', text: 'South Africa' },
  { value: 'GS', text: 'South Georgia and the South Sandwich Islands' },
  { value: 'SS', text: 'South Sudan' },
  { value: 'ES', text: 'Spain' },
  { value: 'LK', text: 'Sri Lanka' },
  { value: 'SD', text: 'Sudan' },
  { value: 'SR', text: 'Suriname' },
  { value: 'SJ', text: 'Svalbard and Jan Mayen' },
  { value: 'SZ', text: 'Swaziland' },
  { value: 'SE', text: 'Sweden' },
  { value: 'CH', text: 'Switzerland' },
  { value: 'SY', text: 'Syrian Arab Republic' },
  { value: 'TW', text: 'Taiwan, Province of China' },
  { value: 'TJ', text: 'Tajikistan' },
  { value: 'TZ', text: 'Tanzania, United Republic of' },
  { value: 'TH', text: 'Thailand' },
  { value: 'TL', text: 'Timor-Leste' },
  { value: 'TG', text: 'Togo' },
  { value: 'TK', text: 'Tokelau' },
  { value: 'TO', text: 'Tonga' },
  { value: 'TT', text: 'Trinidad and Tobago' },
  { value: 'TN', text: 'Tunisia' },
  { value: 'TR', text: 'Turkey' },
  { value: 'TM', text: 'Turkmenistan' },
  { value: 'TC', text: 'Turks and Caicos Islands' },
  { value: 'TV', text: 'Tuvalu' },
  { value: 'UG', text: 'Uganda' },
  { value: 'UA', text: 'Ukraine' },
  { value: 'AE', text: 'United Arab Emirates' },
  { value: 'GB', text: 'United Kingdom' },
  { value: 'UM', text: 'United States Minor Outlying Islands' },
  { value: 'UY', text: 'Uruguay' },
  { value: 'UZ', text: 'Uzbekistan' },
  { value: 'VU', text: 'Vanuatu' },
  { value: 'VE', text: 'Venezuela, Bolivarian Republic of' },
  { value: 'VN', text: 'Viet Nam' },
  { value: 'VG', text: 'Virgin Islands, British' },
  { value: 'VI', text: 'Virgin Islands, U.S.' },
  { value: 'WF', text: 'Wallis and Futuna' },
  { value: 'EH', text: 'Western Sahara' },
  { value: 'YE', text: 'Yemen' },
  { value: 'ZM', text: 'Zambia' },
  { value: 'ZW', text: 'Zimbabwe' }
]

export const countryIsoCodes = {
  AFG: 'AF',
  ALB: 'AL',
  DZA: 'DZ',
  ASM: 'AS',
  AND: 'AD',
  AGO: 'AO',
  AIA: 'AI',
  ATA: 'AQ',
  ATG: 'AG',
  ARG: 'AR',
  ARM: 'AM',
  ABW: 'AW',
  AUS: 'AU',
  AUT: 'AT',
  AZE: 'AZ',
  BHS: 'BS',
  BHR: 'BH',
  BGD: 'BD',
  BRB: 'BB',
  BLR: 'BY',
  BEL: 'BE',
  BLZ: 'BZ',
  BEN: 'BJ',
  BMU: 'BM',
  BTN: 'BT',
  BOL: 'BO',
  BES: 'BQ',
  BIH: 'BA',
  BWA: 'BW',
  BVT: 'BV',
  BRA: 'BR',
  IOT: 'IO',
  BRN: 'BN',
  BGR: 'BG',
  BFA: 'BF',
  BDI: 'BI',
  CPV: 'CV',
  KHM: 'KH',
  CMR: 'CM',
  CAN: 'CA',
  CYM: 'KY',
  CAF: 'CF',
  TCD: 'TD',
  CHL: 'CL',
  CHN: 'CN',
  CXR: 'CX',
  CCK: 'CC',
  COL: 'CO',
  COM: 'KM',
  COD: 'CD',
  COG: 'CG',
  COK: 'CK',
  CRI: 'CR',
  HRV: 'HR',
  CUB: 'CU',
  CUW: 'CW',
  CYP: 'CY',
  CZE: 'CZ',
  CIV: 'CI',
  DNK: 'DK',
  DJI: 'DJ',
  DMA: 'DM',
  DOM: 'DO',
  ECU: 'EC',
  EGY: 'EG',
  SLV: 'SV',
  GNQ: 'GQ',
  ERI: 'ER',
  EST: 'EE',
  SWZ: 'SZ',
  ETH: 'ET',
  FLK: 'FK',
  FRO: 'FO',
  FJI: 'FJ',
  FIN: 'FI',
  FRA: 'FR',
  GUF: 'GF',
  PYF: 'PF',
  ATF: 'TF',
  GAB: 'GA',
  GMB: 'GM',
  GEO: 'GE',
  DEU: 'DE',
  GHA: 'GH',
  GIB: 'GI',
  GRC: 'GR',
  GRL: 'GL',
  GRD: 'GD',
  GLP: 'GP',
  GUM: 'GU',
  GTM: 'GT',
  GGY: 'GG',
  GIN: 'GN',
  GNB: 'GW',
  GUY: 'GY',
  HTI: 'HT',
  HMD: 'HM',
  VAT: 'VA',
  HND: 'HN',
  HKG: 'HK',
  HUN: 'HU',
  ISL: 'IS',
  IND: 'IN',
  IDN: 'ID',
  IRN: 'IR',
  IRQ: 'IQ',
  IRL: 'IE',
  IMN: 'IM',
  ISR: 'IL',
  ITA: 'IT',
  JAM: 'JM',
  JPN: 'JP',
  JEY: 'JE',
  JOR: 'JO',
  KAZ: 'KZ',
  KEN: 'KE',
  KIR: 'KI',
  PRK: 'KP',
  KOR: 'KR',
  KWT: 'KW',
  KGZ: 'KG',
  LAO: 'LA',
  LVA: 'LV',
  LBN: 'LB',
  LSO: 'LS',
  LBR: 'LR',
  LBY: 'LY',
  LIE: 'LI',
  LTU: 'LT',
  LUX: 'LU',
  MAC: 'MO',
  MDG: 'MG',
  MWI: 'MW',
  MYS: 'MY',
  MDV: 'MV',
  MLI: 'ML',
  MLT: 'MT',
  MHL: 'MH',
  MTQ: 'MQ',
  MRT: 'MR',
  MUS: 'MU',
  MYT: 'YT',
  MEX: 'MX',
  FSM: 'FM',
  MDA: 'MD',
  MCO: 'MC',
  MNG: 'MN',
  MNE: 'ME',
  MSR: 'MS',
  MAR: 'MA',
  MOZ: 'MZ',
  MMR: 'MM',
  NAM: 'NA',
  NRU: 'NR',
  NPL: 'NP',
  NLD: 'NL',
  NCL: 'NC',
  NZL: 'NZ',
  NIC: 'NI',
  NER: 'NE',
  NGA: 'NG',
  NIU: 'NU',
  NFK: 'NF',
  MNP: 'MP',
  NOR: 'NO',
  OMN: 'OM',
  PAK: 'PK',
  PLW: 'PW',
  PSE: 'PS',
  PAN: 'PA',
  PNG: 'PG',
  PRY: 'PY',
  PER: 'PE',
  PHL: 'PH',
  PCN: 'PN',
  POL: 'PL',
  PRT: 'PT',
  PRI: 'PR',
  QAT: 'QA',
  MKD: 'MK',
  ROU: 'RO',
  RUS: 'RU',
  RWA: 'RW',
  REU: 'RE',
  BLM: 'BL',
  SHN: 'SH',
  KNA: 'KN',
  LCA: 'LC',
  MAF: 'MF',
  SPM: 'PM',
  VCT: 'VC',
  WSM: 'WS',
  SMR: 'SM',
  STP: 'ST',
  SAU: 'SA',
  SEN: 'SN',
  SRB: 'RS',
  SYC: 'SC',
  SLE: 'SL',
  SGP: 'SG',
  SXM: 'SX',
  SVK: 'SK',
  SVN: 'SI',
  SLB: 'SB',
  SOM: 'SO',
  ZAF: 'ZA',
  SGS: 'GS',
  SSD: 'SS',
  ESP: 'ES',
  LKA: 'LK',
  SDN: 'SD',
  SUR: 'SR',
  SJM: 'SJ',
  SWE: 'SE',
  CHE: 'CH',
  SYR: 'SY',
  TWN: 'TW',
  TJK: 'TJ',
  TZA: 'TZ',
  THA: 'TH',
  TLS: 'TL',
  TGO: 'TG',
  TKL: 'TK',
  TON: 'TO',
  TTO: 'TT',
  TUN: 'TN',
  TUR: 'TR',
  TKM: 'TM',
  TCA: 'TC',
  TUV: 'TV',
  UGA: 'UG',
  UKR: 'UA',
  ARE: 'AE',
  GBR: 'GB',
  UMI: 'UM',
  USA: 'US',
  URY: 'UY',
  UZB: 'UZ',
  VUT: 'VU',
  VEN: 'VE',
  VNM: 'VN',
  VGB: 'VG',
  VIR: 'VI',
  WLF: 'WF',
  ESH: 'EH',
  YEM: 'YE',
  ZMB: 'ZM',
  ZWE: 'ZW',
  ALA: 'AX'
}

export const heightOptions = [
  { value: '', text: '' },
  { value: '7-0', text: '7 feet 0 inches' },
  { value: '6-11', text: '6 feet 11 inches' },
  { value: '6-10', text: '6 feet 10 inches' },
  { value: '6-9', text: '6 feet 9 inches' },
  { value: '6-8', text: '6 feet 8 inches' },
  { value: '6-7', text: '6 feet 7 inches' },
  { value: '6-6', text: '6 feet 6 inches' },
  { value: '6-5', text: '6 feet 5 inches' },
  { value: '6-4', text: '6 feet 4 inches' },
  { value: '6-3', text: '6 feet 3 inches' },
  { value: '6-2', text: '6 feet 2 inches' },
  { value: '6-1', text: '6 feet 1 inches' },
  { value: '6-0', text: '6 feet 0 inches' },
  { value: '5-11', text: '5 feet 11 inches' },
  { value: '5-10', text: '5 feet 10 inches' },
  { value: '5-9', text: '5 feet 9 inches' },
  { value: '5-8', text: '5 feet 8 inches' },
  { value: '5-7', text: '5 feet 7 inches' },
  { value: '5-6', text: '5 feet 6 inches' },
  { value: '5-5', text: '5 feet 5 inches' },
  { value: '5-4', text: '5 feet 4 inches' },
  { value: '5-3', text: '5 feet 3 inches' },
  { value: '5-2', text: '5 feet 2 inches' },
  { value: '5-1', text: '5 feet 1 inches' },
  { value: '5-0', text: '5 feet 0 inches' },
  { value: '4-11', text: '4 feet 11 inches' },
  { value: '4-10', text: '4 feet 10 inches' },
  { value: '4-9', text: '4 feet 9 inches' },
  { value: '4-8', text: '4 feet 8 inches' },
  { value: '4-7', text: '4 feet 7 inches' },
  { value: '4-6', text: '4 feet 6 inches' },
  { value: '4-5', text: '4 feet 5 inches' },
  { value: '4-4', text: '4 feet 4 inches' },
  { value: '4-3', text: '4 feet 3 inches' },
  { value: '4-2', text: '4 feet 2 inches' },
  { value: '4-1', text: '4 feet 1 inches' },
  { value: '4-0', text: '4 feet 0 inches' },
  { value: '3-11', text: '3 feet 11 inches' },
  { value: '3-10', text: '3 feet 10 inches' },
  { value: '3-9', text: '3 feet 9 inches' },
  { value: '3-8', text: '3 feet 8 inches' },
  { value: '3-7', text: '3 feet 7 inches' },
  { value: '3-6', text: '3 feet 6 inches' },
  { value: '3-5', text: '3 feet 5 inches' },
  { value: '3-4', text: '3 feet 4 inches' },
  { value: '3-3', text: '3 feet 3 inches' },
  { value: '3-2', text: '3 feet 2 inches' },
  { value: '3-1', text: '3 feet 1 inches' },
  { value: '3-0', text: '3 feet 0 inches' }
]

// DynamoDB reorders links
export const disclosuresLinksOrder = [
  'ElectronicDisclosuresConsent',
  'PrivacyPolicy',
  'CreditTaC',
  'TitlemaxWebsiteToU',
  'ExperianConsent'
]

export const footerListOrder = [
  'accessibilityStatement',
  'websiteTermsOfUse',
  'fedPrivacyPolicy',
  'privacyPolicy',
  'ratesAndTerms',
  'stateLicense',
  'aboutUs',
  'faq',
  'contactUs'
]

export const underlinedFooterListOrder = [
  'caliPrivacyPolicy',
  'doNotSell',
  'limitInformation'
]

export const vehicleTypesConstant = [
  { value: 'AUTOMOBILE', text: 'Automobile' },
  { value: 'MOTORCYCLE', text: 'Motorcycle' },
  { value: 'RECREATIONAL_VEHICLE', text: 'RV' }
]

export const AppraisalStatuses = {
  ackddo_app: 'ackddo_app',
  ackddo_aud: 'ackddo_aud',
  advgivn: 'adv-givn',
  advrequ: 'adv-requ',
  audit: 'audit',
  complete: 'complete',
  desk_over_cmp: 'desk_over_cmp',
  desk_over_req: 'desk_over_req',
  ddo_acv: 'ddo_acv',
  ddo_aud: 'ddo_aud',
  ddo_app: 'ddo_app',
  inProgress: 'inprog',
  preapp: 'preapp',
  postapp: 'postapp',
  postaud: 'postaud',
  postddo_app: 'postddo_app',
  postddo_aud: 'postddo_aud',
  start: 'start',
  declined: 'declined',
  withdraw: 'withdraw'
}

export const MobileMoneyStoreBrands = {
  cs: 'CheckSmart',
  chs: 'CheckSmart',
  cic: 'Check Into Cash',
  inl: 'InstaLoan',
  spc: 'Speedy Cash',
  src: 'Speedy Cash',
  tbs: 'TitleBucks',
  tmx: 'TitleMax'
}

// List of states released before May 2020
export const BankingInfoTermsOptionBStates = ['DE', 'MO', 'SC', 'TX', 'UT', 'WI']

export const romanNumerals = [
  'i',
  'ii',
  'iii',
  'iv',
  'v',
  'vi',
  'vii',
  'viii',
  'ix',
  'x',
  'xi',
  'xii',
  'xiii',
  'xiv',
  'xv',
  'xvi',
  'xvii',
  'xviii',
  'xix',
  'xx'
]

export const CustLoanTypeSelection = {
  titleLoan: 1,
  signatureLoan: 2
}

export const MarketingProductTypeCodes = {
  signatureLoan: 'Online Signature Loan',
  titleLoan: 'Online 1st Lien Loan'
}

export const signatureBorrowMax = 250

export const footerLinkLabels = {
  termsOfUse: 'Terms of Use',
  privacyPolicy: 'Privacy Notice'
}

export const suffixOptions = [
  { value: '', text: ' ' },
  { value: 'Jr.', text: 'Jr.' },
  { value: 'Sr.', text: 'Sr.' },
  { value: 'II', text: 'II' },
  { value: 'III', text: 'III' },
  { value: 'IV', text: 'IV' },
  { value: 'V', text: 'V' }
]

export const defaultFooterLinksTitleMaxBucks = {
  accessibilityStatement: {
    label: 'Accessibility Statement',
    tbs: 'https://www.tmxdisclosures.com/titlebucks/accessibility-statement',
    tmx: 'https://www.tmxdisclosures.com/titlemax/accessibility-statement'
  },
  contactUs: {
    label: 'Contact Us',
    tbs: 'https://www.titlebucks.com/contact-us/',
    tmx: 'https://www.titlemax.com/contact-us/'
  },
  faq: {
    label: 'FAQs',
    tbs: 'https://www.titlebucks.com/faqs/',
    tmx: 'https://www.titlemax.com/faqs/'
  },
  privacyPolicy: {
    label: 'Privacy Notice',
    tbs: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice',
    tmx: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice'
  },
  websiteTermsOfUse: {
    label: 'Terms of Use',
    tbs: 'https://www.tmxdisclosures.com/titlebucks/terms-of-use',
    tmx: 'https://www.tmxdisclosures.com/titlemax/terms-of-use'
  }
}

export const defaultFooterLinksInstaloan = {
  accessibilityStatement: {
    label: 'Accessibility Statement',
    inl: 'https://www.tmxdisclosures.com/instaloan/accessibility-statement'
  },
  contactUs: {
    label: 'Contact Us',
    inl: 'https://www.instaloan.com/contact/'
  },
  faq: {
    label: 'FAQs',
    inl: 'https://www.instaloan.com/faqs/'
  },
  loanTypes: {
    label: 'Loan Types',
    inl: 'https://www.instaloan.com/florida-loans/'
  },
  privacyPolicy: {
    label: 'Privacy Notice',
    inl: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice'
  },
  websiteTermsOfUse: {
    label: 'Terms of Use',
    inl: 'https://www.tmxdisclosures.com/instaloan/terms-of-use'
  }
}

export const defaultFooterLinksCcfi = {
  accessibilityStatement: {
    chs: 'https://assets-us-01.kc-usercontent.com/673ea2f7-d1db-0049-fc7b-f932cff71cf7/60de1e67-2f26-42c4-92d8-35f16d51f2bf/accessibility-statement-checkSmart-11-29-2023.pdf',
    cic: 'https://www.checkintocash.com/wp-content/uploads/Accessibility-Statement-Check-Into-Cash-11.29.2023.pdf',
    label: 'Accessibility Statement',
    spc: 'https://www.speedycash.com/accessibility-statement/'
  },
  ArizonaStatue: {
    chs: 'https://assets-us-01.kc-usercontent.com/673ea2f7-d1db-0049-fc7b-f932cff71cf7/853a14c2-ba79-4418-b979-cadc156e2fa8/az-notice.pdf',
    cic: 'https://www.checkintocash.com/wp-content/uploads/AZ-Notice-generic.pdf',
    label: 'Arizona Notice',
    spc: 'https://assets-us-01.kc-usercontent.com/79cae174-e6e3-0054-0122-d8d0d63f667f/dd8e90cb-d6d1-4e76-a374-b5d994ed6ed6/az-notice.pdf'
  },
  contactUs: {
    chs: 'https://www.checksmart.com/contact/',
    cic: 'https://www.checkintocash.com/contact-us/',
    label: 'Contact Us',
    spc: 'https://www.speedycash.com/contact-us/'
  },
  faq: {
    label: 'FAQs',
    tbs: 'https://www.titlebucks.com/faqs/',
    tmx: 'https://www.titlemax.com/faqs/'
  },
  privacyPolicy: {
    chs: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice',
    cic: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice',
    label: 'Privacy Notice',
    spc: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice'
  },
  websiteTermsOfUse: {
    chs: 'https://www.checksmart.com/terms-of-use/',
    cic: 'https://www.checkintocashonline.com/TermsOfUse',
    label: 'Terms of Use',
    spc: 'https://www.speedycash.com/terms-of-use/'
  }
}

export const defaultFooterLinksEsm = {
  accessibilityStatement: {
    label: 'Accessibility Statement',
    esm: 'https://tmxdisclosures.com/easymoney/em-accessibility-statement'
  },
  privacyPolicy: {
    label: 'Privacy Notice',
    esm: 'https://disclosures.ccffamilyofbrands.com/ccf/fed-privacy-notice'
  },
  websiteTermsOfUse: {
    label: 'Terms of Use',
    esm: 'https://tmxdisclosures.com/easymoney/em-terms-of-use'
  }
}
